<template>
  <v-sheet color="#F7F7F7" tag="section">
    <v-container class="item">
      <v-row align="center" justify="center">
        <v-col
          :class="{ 'pr-md-16': item.img }"
          cols="12"
          sm="10"
          :md="!item.img ? 8 : 6"
        >
          <TitleWidget :align="!item.img || smAndDown ? 'center' : 'left'">
            {{ item.title }}
          </TitleWidget>

          <img
            v-if="smAndDown && item.img"
            class="d-block mt-6 item-img"
            :src="files + item.img + '?resize=1&w=960'"
            :alt="item.title"
            width="100%"
            height="100%"
          />

          <div
            v-if="smAndDown && item.research > 1"
            class="d-flex justify-center"
          >
            <v-sheet
              class="
                d-flex
                align-center
                justify-center
                flex-column
                text-center
                py-5
                px-10
                item-research
              "
            >
              <div
                class="
                  primary--text
                  text-body-2
                  font-weight-medium
                  text-uppercase
                "
              >
                {{ research.before }}
              </div>
              <div
                class="secondary--text text-h4 font-weight-bold text-uppercase"
              >
                {{ item.research }}
              </div>
              <div
                class="
                  primary--text
                  text-body-2
                  font-weight-medium
                  text-uppercase
                "
              >
                {{ research.after }}
              </div>
            </v-sheet>
          </div>

          <div
            class="
              grey--text
              text--darken-1 text-body-1 text-center text-md-left
              font-weight-regular
              mt-6
              ck-content
              item-text
            "
            v-html="item.introduction || item.text"
          ></div>

          <ButtonWidget
            class="mt-6 mt-md-8"
            color="primary"
            text-color="white"
            :align="smAndDown ? 'center' : 'left'"
            :to="path"
          >
            Saiba Mais
          </ButtonWidget>
        </v-col>

        <v-col v-if="!smAndDown && item.img" cols="12" sm="10" md="6">
          <div class="position-relative">
            <img
              class="d-block item-img"
              :src="files + item.img + '?resize=1&w=960'"
              :alt="item.title"
              width="100%"
              height="100%"
            />

            <v-sheet
              v-if="item.research > 1"
              class="
                d-flex
                align-center
                justify-center
                flex-column
                text-center
                py-8
                px-16
                item-research
              "
            >
              <div
                class="
                  primary--text
                  text-body-1
                  font-weight-medium
                  text-uppercase
                "
              >
                {{ research.before }}
              </div>
              <div
                class="secondary--text text-h3 font-weight-bold text-uppercase"
              >
                {{ item.research }}
              </div>
              <div
                class="
                  primary--text
                  text-body-1
                  font-weight-medium
                  text-uppercase
                "
              >
                {{ research.after }}
              </div>
            </v-sheet>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "about",
  path: "/sobre",
};

const _data = {
  path: _config.path,
  research: {
    before: "Já são",
    after: "pesquisas realizadas",
  },
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    TitleWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  @media screen and (min-width: 960px) {
    margin-bottom: 30px;
  }

  &-img {
    aspect-ratio: 600 / 440;
    object-fit: cover;
  }

  &-text {
    line-height: 1.8;
  }

  &-research {
    border-radius: 10px;
    box-shadow: 0px 50px 70px -20px rgba(38, 20, 94, 0.15);

    @media screen and (min-width: 960px) {
      bottom: -30px;
      left: -30px;
      position: absolute;
    }

    @media screen and (max-width: 959.9px) {
      margin-top: -60px;
    }
  }
}
</style>
